import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "tax-law.webp",
    title: "Tax Law",
    crumb: "Tax Law",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "Comprehensive tax advice for maritime, port, and foreign trade companies: tax optimization, incentives, and formal compliance.",

  title: "Tax Law",
  features: {
    title: "Tax Law",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Strategic analysis of tax obligations, incentives, and customs planning for the maritime and logistics sector.",
    description: `Specialized tax advice on income tax, VAT, parafiscal contributions, and social security applicable to the maritime and port sector. We evaluate the business model, operational location (free zones / SEZ), formal obligations, incentives, and international schemes when applicable, designing a compliance and tax optimization plan tailored to operational and regulatory risk.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "activity",
        title: "Identification of the type of economic activity and business model",
        summary:
          "We classify the activity (maritime transport, agency, stevedoring, logistics, offshore services) to determine the applicable tax treatment.",
        details:
          "We carry out a diagnosis of the business model to identify the nature of the income and its tax framework: activities subject to income tax, operations subject to or exempt from VAT, treatment of income from freight, commissions, and related services. This analysis is the basis for defining the tax regime, withholding obligations, and accounting formalities.",
        deliverables: [
          "Economic classification and tax risk report",
          "Income flow map and its tax treatment",
          "Recommendations for billing and contract structure"
        ],
        requiredDocs: [
          "Corporate purpose and bylaws",
          "Commercial and charter contracts",
          "Representative account statements and billing"
        ],
        icon: "fa-solid fa-briefcase",
        image: global.services + "tax_law/1.webp",
      },
      {
        key: "location",
        title:
          "Evaluation of geographic location and its tax implications (free zones / SEZ)",
        summary:
          "We analyze the tax and customs impact according to the operational location (free zone, SEZ, national port), identifying incentives and requirements.",
        details:
          "We determine if the operation can benefit from special regimes (Special Economic Zones / Free Zones), the conditions to access benefits (VAT/income tax exemptions, refunds, accelerated depreciation) and the formal requirements. We also evaluate associated customs obligations and the benefits of draw-back or tariff refunds.",
        deliverables: [
          "Eligibility report for SEZ/Free Zone",
          "Checklist of requirements for access to incentives",
          "Territorial implementation plan"
        ],
        requiredDocs: [
          "Fiscal and operational address",
          "Port permits and licenses",
          "Import/export documentation"
        ],
        icon: "fa-solid fa-location-dot",
        image: global.services + "tax_law/2.webp",
      },
      {
        key: "taxes",
        title: "Determination of applicable direct and indirect taxes (VAT, income tax, INCES, IVSS, etc.)",
        summary:
          "We identify and quantify the taxes and parafiscal contributions that affect business operations.",
        details:
          "We prepare a matrix that relates each income/expense line to its corresponding tax: VAT treatment (taxable or exempt), rules for income tax (tax base, withholdings and advances), obligations to INCES (contributions) and IVSS, and other local or special taxes. Includes compliance and optimization recommendations within the current legal framework and proper accounting records.",
        deliverables: [
          "Summary table of applicable taxes by operational flow",
          "Annual tax burden simulation",
          "Procedure for calculating withholdings and advances"
        ],
        requiredDocs: [
          "Recent tax returns",
          "Accounting books and sales/purchase records",
          "Representative contracts and invoices"
        ],
        icon: "fa-solid fa-coins",
        image: global.services + "tax_law/3.webp",
      },
      {
        key: "obligations",
        title: "Determination of formal obligations: accounting books, returns, and withholdings",
        summary:
          "We audit and define formal obligations before SENIAT and related entities: books, periodic returns, and withholdings.",
        details:
          "We review compliance with books and records required by regulations, monthly/annual return obligations (VAT/income tax), accounting reconciliations, and procedures for withholdings to suppliers and staff. We prepare templates, calendars, and internal guidelines to reduce the risk of fines and administrative sanctions.",
        deliverables: [
          "Formal compliance checklist and tax calendar",
          "Templates for books and reports (digital/printed)",
          "Procedure for withholdings and audit support"
        ],
        requiredDocs: [
          "Accounting books and records",
          "Withholding receipts and supporting documents",
          "Internal control policies"
        ],
        icon: "fa-solid fa-file-invoice-dollar",
        image: global.services + "tax_law/4.webp",
      },
      {
        key: "incentives",
        title: "Application of tax incentives and planning of deductions and credits",
        summary:
          "We detect applicable incentives, exemptions, and deductions and design plans for their legal use.",
        details:
          "We analyze available incentives (SEZ, income tax/VAT refunds, accelerated depreciation, investment incentives) and propose documentation and flows that maximize deductions and tax credits. Includes preparation of exemption requests and follow-up with competent authorities when applicable.",
        deliverables: [
          "List of applicable incentives with estimated calculations",
          "Request models and support for exemptions",
          "Annual tax optimization plan"
        ],
        requiredDocs: [
          "Financial statements",
          "Investment and deductible expense receipts",
          "Zone or special regime certificates (if applicable)"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "tax_law/5.webp",
      },
      {
        key: "planning",
        title: "Evaluation of international structures and customs strategies",
        summary:
          "We study the need for international structures (holding, subsidiaries) and design customs strategies to optimize costs and compliance.",
        details:
          "We carry out international planning analysis considering current double taxation agreements and the convenience of intermediate companies (holding) or subsidiaries. We develop customs strategies for import/export (regimes, simplified clearance, draw-back) minimizing risks and logistical and tax costs, always within the applicable legal framework.",
        deliverables: [
          "Evaluation of the convenience of international structure",
          "Map of international tax risks",
          "Operational and compliance customs plan"
        ],
        requiredDocs: [
          "Current corporate structure",
          "International contracts and import/export billing",
          "Previous customs documentation"
        ],
        icon: "fa-solid fa-globe",
        image: global.services + "tax_law/6.webp",
      }
    ],
  },
  ctaText: "Request tax advice",
  ctaLink: "/contact?service=tax-law",
};
